import { render, staticRenderFns } from "./ProductDetailDesktop.vue?vue&type=template&id=5d464472"
import script from "./ProductDetailDesktop.vue?vue&type=script&lang=js"
export * from "./ProductDetailDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailDesktop.vue?vue&type=style&index=0&id=5d464472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports